import { render, staticRenderFns } from "./DayReport.vue?vue&type=template&id=2b6d7dd3&"
import script from "./DayReport.vue?vue&type=script&lang=js&"
export * from "./DayReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports